document.addEventListener('DOMContentLoaded', () => {
  const galleryFields = document.querySelectorAll('[installation-guide]');
  const sortSequence = [
    'all',
    'porsche',
    'bmw',
    'toyota',
    'tesla',
    "honda",
    'subaru',
    'ford',
    'chevrolet',
    'hyundai',
    'genesis', 
    'kia',
  ];
  function sortFilterItems() {
    galleryFields.forEach((dropdown) => {
      const filterList = dropdown.querySelector('[data-guide-filter-list]');
      if (filterList) {
        const items = Array.from(filterList.children);
        items.sort((a, b) => {
          const aBrand = a.getAttribute('data-brand')?.toLowerCase() || '';
          const bBrand = b.getAttribute('data-brand')?.toLowerCase() || '';
          return sortSequence.indexOf(aBrand) - sortSequence.indexOf(bBrand);
        });
        items.forEach((item) => filterList.appendChild(item));
      }
    });
  }
  sortFilterItems();
  galleryFields.forEach((dropdown) => {
    const brandSelectedField = dropdown.querySelector('[filter-brand-selected-field]');
    const modelSelectedField = dropdown.querySelector('[filter-model-selected-field]');
    const options = dropdown.querySelectorAll('[data-filter-item]');

    if (brandSelectedField) {
      brandSelectedField.addEventListener('click', (event) => {
        event.stopPropagation();

        const isOpen = dropdown.classList.contains('open');
        galleryFields.forEach((dd) => dd.classList.remove('open'));
        dropdown.classList.toggle('open', !isOpen);
      });
    }

    if (modelSelectedField) {
      modelSelectedField.addEventListener('click', (event) => {
        event.stopPropagation();

        const isOpen = dropdown.classList.contains('open');
        galleryFields.forEach((dd) => dd.classList.remove('open'));
        dropdown.classList.toggle('open', !isOpen);
      });
    }

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('open');
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.textContent.trim();
        const trigger = dropdown.querySelector('[filter-selected-value]');

        if (trigger) {
          trigger.textContent = value;
        }

        dropdown.classList.remove('open');

        const modelDisabledRemove = document.querySelector('[filter-model-selected-field]');
        if (modelDisabledRemove) {
          modelDisabledRemove.classList.remove('disabled');
        }

        if (dropdown.closest('[data-guide-filter-brand]')) {
          const selectedBrand = option.getAttribute('data-brand');
          if (selectedBrand === 'all') {
            showAllItems();
          } else {
            filterModels(selectedBrand);
          }
        }

        if (dropdown.closest('[data-guide-filter-model]')) {
          const selectedModel = option.getAttribute('data-model');
          filterGuides(selectedModel);
        }
      });
    });
  });

  function showAllItems() {
    const modelOptions = document.querySelectorAll('[data-guide-filter-model] [data-filter-item]');
    modelOptions.forEach((option) => option.classList.remove('hidden'));
    const modelTrigger = document.querySelector('[data-guide-filter-model] [filter-selected-value]');
    if (modelTrigger) {
      modelTrigger.textContent = 'Select a Model';
    }
    const articles = document.querySelectorAll('[data-guide-brand], [data-guide-model]');
    articles.forEach((article) => article.classList.remove('hidden'));
  }

  function filterModels(selectedBrand) {
    const modelOptions = document.querySelectorAll('[data-guide-filter-model] [data-filter-item]');

    modelOptions.forEach((option) => {
      const brandName = option.getAttribute('data-brand-name');
      if (brandName === selectedBrand) {
        option.classList.remove('hidden');
      } else {
        option.classList.add('hidden');
      }
    });

    const modelTrigger = document.querySelector('[data-guide-filter-model] [filter-selected-value]');
    if (modelTrigger) {
      modelTrigger.textContent = 'Select a Model';
    }

    filterGuidesByBrand(selectedBrand);
  }

  function filterGuidesByBrand(selectedBrand) {
    const guides = document.querySelectorAll('[data-guide-brand]');

    guides.forEach((guide) => {
      const guideBrand = guide.getAttribute('data-guide-brand');
      if (guideBrand === selectedBrand) {
        guide.classList.remove('hidden');
      } else {
        guide.classList.add('hidden');
      }
    });
  }

  function filterGuides(selectedModel) {
    const guides = document.querySelectorAll('[data-guide-model]');

    guides.forEach((guide) => {
      const guideModel = guide.getAttribute('data-guide-model');
      if (guideModel === selectedModel) {
        guide.classList.remove('hidden');
      } else {
        guide.classList.add('hidden');
      }
    });
  }
});